import React from 'react';
import styles from './index.module.less';

const TopBlank = (props): JSX.Element => {
  return <div className={styles.topBlank} />;
};

export default TopBlank;
